import { SmartTable } from '../../../../../components/smart-table/smart-table.model';
import { resolve } from '../../../../../init/store';

export class Controller {

    /** @ngInject */
    constructor(Alert, SharedAccountsService) {
        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
    }

    $onInit() {
        this.st = new SmartTable();
        this.showOtpEnabled = false;
        this.showPasswordEnabled = false;
        this.isSelectable = this.isSelectable.bind(this);
    }

    ifSelectable(authenticator) {
        return this.isSelectable(authenticator) && authenticator;
    }

    isSelectable(authenticator) {
        const hasServiceUrl = !!(authenticator.publicService || {}).serviceUrl;
        const customUrlRequired = !!(authenticator.publicService || {}).urlRequired;
        const hasCustomUrl = !!(authenticator.customLoginUrl || {}).serviceLoginUrl;
        return hasServiceUrl && !customUrlRequired || hasCustomUrl;
    }

    save() {
        this.isSaving = true;
        this.SharedAccountsService
            .importCompanyServiceAccounts(
                {
                    companyId: resolve.companyId,
                    showOtp: this.showOtpEnabled,
                    showPassword: this.showPasswordEnabled,
                },
                this.st.selectedIds,
            )
            .$promise
            .then(accounts => {
                this.close({$value: accounts});
                this.Alert('success', 'company.sharing-center.import.imported');
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/import/import-shared-authenticator.controller.js